import {
  Component,
  HostBinding,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { QueueWithExt } from "../../../acdQueuesPage/acd-queues-page.component";
import { ringStrategyMap } from "../../../helpers/acd-queues-dropdown-options";

@Component({
  selector: "onsip-acd-queues-agent-view",
  templateUrl: "./acd-queues-agent-settings-view.component.html",
  styleUrls: ["../acdQueuesAgentSettingsEdit/acd-queues-agent-settings-edit.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AcdQueuesAgentViewComponent {
  @HostBinding("class.onsip-grid-content")
  @HostBinding("class.onsip-admin-host-grid")
  _dontUse = true;
  @Input() queue!: QueueWithExt;
  @Output() editPanel = new EventEmitter<void>();

  loginExtensions: Array<string> = [];
  ringStrategyMap = ringStrategyMap;

  constructor() {}

  togglePanel(): void {
    this.editPanel.emit();
  }
}
